export default "__VITE_ASSET__3c5e03ce__"